// Copyright (c) Qualcomm Technologies, Inc. and/or its subsidiaries.
// SPDX-License-Identifier: BSD-3-Clause-Clear

export const notificationClasses = {
  action: "qui-notification__action",
  closeButton: "qui-notification__close-button",
  description: "qui-notification__description",
  icon: "qui-notification__icon",
  label: "qui-notification__label",
  root: "qui-notification__root",
} as const
